/* eslint-disable @eslint-react/dom/no-dangerously-set-innerhtml */

export interface QuoteProps {
    body?: string | null;
    caption?: string | null;
    className?: string | null;
}

function Quote({ body = null, caption = null, className = null }: QuoteProps) {
    return (
        <figure className={className ?? undefined}>
            <blockquote dangerouslySetInnerHTML={{ __html: body ?? '' }} />
            {caption !== null ? (
                <figcaption dangerouslySetInnerHTML={{ __html: caption ?? '' }} />
            ) : null}
        </figure>
    );
}

export default Quote;
